export default __webpack_public_path__ + "static/media/Xrathus-Bichronous-Process-diagram.9325b304.png";